<div class="m-content">
	<div class="m-portlet">
		<div class="m-portlet__head">
			<div class="m-portlet__body1 form-group m-form__group row">
				<div class="col-6">
					<h4 class="m-portlet__head-text">
						Payment History
					</h4>
				</div>
				<div class="col-6 text-center">
					<div class="m-demo__preview m-demo__preview--btn">
						<button type="button" class="btn btn-secondary btn-md" (click)="goBack()">Back</button>
					</div>
				</div>

			</div>
		</div>
		<div class="m-portlet__body">
			<div class="col-md-12">
				<div class="tab-content">

					<!-- start of search -->
					<div class='row searchTransaction'>
						<div class='col-2'></div>
						<div class='col-5 input-group'>
							<div class="m-radio-inline">
								<label></label>
								<label class="m-radio">
									<input type="radio" name="example_3" [(ngModel)]="transaction.isComplete"
										value="true"> All Successful Transaction
									<span></span>
								</label>
								<label class="m-radio">
									<input type="radio" name="example_3" [(ngModel)]="transaction.isComplete"
										value="false"> All Attemps Transaction
									<span></span>
								</label>
							</div>
						</div>
						<div class='col-2'></div>
						<div class='col-2 input-group'>
							<label></label>
							<div class="input-group">
								<button class='btn btn-next form-control'
									(click)="searchByTransaction()">Search</button>
							</div>
						</div>
					</div>
					<div class='row searchTransaction'>
						<div class='col-1'></div>
						<div class='col-4 input-group'>
							<label></label>
							<div class="m-radio-inline">
								<label class="m-radio">
									<input type="radio" name="example_4" [(ngModel)]="merchantId.merchantId"
										[value]="'merchantId'"> Merchant ID
									<span></span>
								</label>

								<label class="m-radio">
									<input type="radio" name="example_4" [(ngModel)]="merchantId.merchantId"
										[value]="'tranctnID'"> Tranaction ID
									<span></span>
								</label>
								<!-- <label class="m-radio">
									<input type="radio" name="example_4" [(ngModel)]="merchantId.merchantId"
										[value]="'userName'"> User Name
									<span></span>
								</label> -->
								<label class="m-radio">
									<input type="radio" name="example_4" [(ngModel)]="merchantId.merchantId"
										class="check" checked="checked" [value]="'sequenceId'"> Order Id
									<span></span>
								</label>
							</div>

						</div>
						<div class='col-4'>
							<div class="search-input">
								<input type="text" class="form-control m-input"
									placeholder="Enter Merchant ID/Transaction ID/Order Id"
									[(ngModel)]="trasactionIds[merchantId.merchantId]" />
								<span class="mandatory">{{errMsgID}}</span>
							</div>
						</div>
						<div class='col-2 input-group'>
							<label></label>
							<button class='btn btn-next form-control' (click)='searchById()'>Search</button>
						</div>
					</div>
					<form [formGroup]='filterForm'>


						<div class='row'>
							<div class='col-5'>
								<label></label>
								<div class="input-group">
									<app-date-duration [formElement]="durationFields"
										[formValue]="this.filterForm.get('date')">
										<span class="mandatory">{{errMsgDate}}</span>
									</app-date-duration>

								</div>
							</div>
							<div class='col-2'>
								<label></label>
								<div class="input-group">
									<button class='btn btn-next form-control' (click)='filterApply()'>Filter By
										Date</button>
								</div>
							</div>
							<div class='col-2'>
								<label></label>
								<div class="input-group">
									<button class='btn btn-secondary' (click)="reset()">Reset</button>
								</div>
							</div>

							<!-- <div class='col-2'>
								<label></label>
								<div class="input-group">
									<button class='btn btn-success form-control' (click)='apply()'>Export To
										Excel</button>
								</div>
							</div> -->
						</div>

					</form>
					<!-- end of search -->

					<div class="table-responsive">
						<table class="notranslate table table-bordered">
							<thead>
								<tr>
									<th class="text-center">Sr. No</th>
									<th class="text-center">Download Invoice</th>
									<!-- <th class="align-middle">Status</th> -->
									<th class="text-center">Payment By</th>
									<th class="text-center">Order/Payment ID</th>
									<th class="align-middle">Transaction ID</th>
									<!-- <th class="text-center">Merchant ID</th> -->
									<th class="align-middle">Invoice No</th>
									<th class="text-center">TP/TC Name</th>
									<th class="text-center">User Name</th>
									<th class="align-middle">TP ID</th>
									<th class="text-center">Type of Training Center</th>
									<th class="text-center">Type of Residential Facility</th>
									<th class="align-middle">Fee Description</th>
									<th class="align-middle">SSC Name</th>
									<th class="align-middle">QP Code</th>
									<th class="text-center">Application Fees</th>
									<th class="text-center">Job Role Fees</th>
									<th class="text-center">Residential Fees</th>
									<th class="text-center">Conv Fees</th>
									<th class="text-center">Total Amount</th>
									<th class="text-center">Transaction Date</th>
									<th class="text-center">Transaction Result</th>
									<th class="align-middle">State</th>
									<th class="align-middle">District</th>
									<th class="text-center">Payment Mode</th>
									<th class="text-center">Refund Date</th>
									<th class="text-center">Reference No</th>
									<th class="text-center">Refund Status</th>
									<th class="text-center">Refund Mode</th>
									<th class="text-center">Refund By</th>
									<th class="text-center">Refund Amount</th>
									<th class="align-middle">Remarks</th>
									<th *ngIf="loggedInUserInfo.role !=='Training Partner'" class="align-middle">Action
									</th>
								</tr>
							</thead>
							<tbody class="m-datatable__body">
								<ng-container *ngIf="paymentData && paymentData.length !== 0;">
									<tr *ngFor="let payment of paymentData; index as i"
										[style.background-color]=statusColor[payment?.eligibleForRDG]>
										<th scope="row" class="align-middle">{{i+1}}</th>
										<td>
											<div class="col-form-label col-lg-3 col-md-3 col-sm-3">
												<b class="document_link m--font-info text-center"
													(click)="downloadCertificate(payment.receiptPath,payment.orderId)">Download
													Invoice</b>
											</div>
										</td>
										<!-- <td class="text-center">{{payment.actorStatusTPTC}}</td> -->
										<td class="text-center">{{payment.paymentBy}}</td>
										<td class="text-center">{{payment.orderId}}</td>
										<td class="text-center">{{payment.tranctnID}}</td>
										<!-- <td class="text-center">{{payment.merchantId}}</td> -->
										<td class="text-center">{{payment.invoiceNo}}</td>
										<td class="text-center">{{payment.name}}</td>
										<td class="text-center">{{payment.userName}}</td>
										<td class="text-center">{{payment.tpId}}</td>
										<td class="text-center">{{payment.typeOfTc}}</td>
										<td class="text-center">
											<span *ngIf="payment?.residentialMen=='true'"> Men </span><span
												*ngIf="payment?.residentialWomen=='true'">,</span>
											<span *ngIf="payment?.residentialWomen=='true'"> Women </span><span
												*ngIf="payment?.residentialTransgender=='true'">,</span>
											<span *ngIf="payment?.residentialTransgender=='true'"> Transgender </span>
										</td>
										<td class="text-center">{{payment.feeDescription}}</td>
										<td class="text-center">{{payment.sscName}}</td>
										<td class="text-center">{{payment.qpCode}}</td>
										<td *ngIf="payment.feeDescription == 'Inspection Fee' || payment.feeDescription == 'Re-Inspection Fee'; else applicationFees"
											class="text-center">10000</td>
										<ng-template #applicationFees>
											<td class="text-center">{{payment.applicationFees}}</td>
										</ng-template>
										<td class="text-center">{{getjobRoleFees(payment)}}</td>
										<td class="text-center">
											{{payment.residentialAmount ? payment.residentialAmount:"-"}}</td>
										<td class="text-center">{{payment.conversationFees}}</td>
										<td class="text-center">{{payment.totalAmount}}</td>
										<td class="text-center">
											{{convertDateFormat(payment.transactiondate)| date:'dd/MM/yyyy'}}</td>
										<td class="text-center">{{payment.transactionResult}}</td>
										<td class="text-center">{{payment.state}}</td>
										<td class="text-center">{{payment.district}}</td>
										<td class="text-center">{{payment.paymentMode}}</td>
										<td class="text-center">{{payment.refundDate |date:'dd/MM/yyyy'}}</td>
										<td class="text-center">{{payment.referenceNo}}</td>
										<td class="text-center">{{getRefundStatus(payment)}}</td>
										<td class="text-center">{{payment.refundMode}}</td>
										<td class="text-center">{{payment.refundBy}}</td>
										<td class="text-center">{{payment.refundAmount}}</td>
										<td class="text-center">{{payment.refundReviews}}</td>
										<td *ngIf="loggedInUserInfo.role !=='Training Partner'">
											<span>
												<div class="dropdown align-middle">
													<a href="#"
														class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
														data-toggle="dropdown">
														<i class="la la-ellipsis-h"></i>
													</a>
													<!-- *ngIf="payment.paymentBy === 'Training Centre'" -->
													<div class="dropdown-menu dropdown-menu-right">

														<a class="dropdown-item" (click)="applyForRefund(payment)"
															*ngIf="canApplyforrefundDuetoguidlinesChange(payment)">
															Apply for Refund
														</a>
														<a class="dropdown-item"
															(click)="applyForRefund(payment, 'Duplicate Refund')"
															*ngIf="canApplyforrefund(payment)">
															Duplicate Refund
														</a>
														<a class="dropdown-item"
															(click)="applyForRefund(payment, 'Re-inspection or Re-Accreditation')"
															*ngIf="canApplyforrefundReinsReAccr(payment)">
															Refund for paid Re-inspection as well as Re-Accreditation
														</a>
														<!-- <a class="dropdown-item"
															(click)="applyForRefund(payment, 'Others')"
															*ngIf="canApplyforrefund(payment)">
															Others
														</a> -->
														<a class="dropdown-item" (click)="viewCommentsDetails(payment)">
															View Comments
														</a>
													</div>
												</div>
											</span>
										</td>
									</tr>
								</ng-container>
								<ng-template *ngIf="count == 0;">
									<!-- <span class="text-center red">No Payment Found</span> -->
									<div class="col-12 text-center text-danger" style="width:100%">
										<p> No Payment Found ... </p>
									</div>
								</ng-template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="count>10">
		<app-pagination [count]="count" (pageNumber)="onPageChange($event)" [defaultRecordsPerPage]="itemsPerPage"
			(recordsPerPage)="onRequiredPerPageChage($event)"></app-pagination>
	</div>
</div>

<div class="modal fade" id="refund-bank-details" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Fill the Bank Details
				</h5>
			</div>
			<form class="m-form m-form--fit m-form--label-align-right" [formGroup]="refundBankDetailsForm"
				style="margin-top:20px;">
				<div class="m-form__group form-group row">
					<label for="tp-details" class="col-2 col-form-label">
						TC ID
					</label>
					<div class="col-7">
						<input class="form-control m-input" type="text" placeholder="TC ID"
							[ngModel]="loggedInUserInfo.userName" disabled [ngModelOptions]="{standalone: true}">
						<!-- <app-form-control-messages [control]="refundBankDetailsForm.controls.email" [name]="'Email Address'"></app-form-control-messages> -->
					</div>
				</div>
				<div class="m-form__group form-group row">
					<label for="tp-details" class="col-2 col-form-label">
						Branch Name
					</label>
					<span class="text-danger text-position">*</span>
					<div class="col-7">
						<input class="form-control m-input" type="text" name="branch name"
							placeholder="Enter the Branch Name" formControlName="branchName">
						<app-form-control-messages [control]="refundBankDetailsForm.controls.branchName"
							[name]="'Branch Name'">
						</app-form-control-messages>
					</div>
				</div>
				<div class="m-form__group form-group row">
					<label for="tp-details" class="col-2 col-form-label">
						Bank Name
					</label>
					<span class="text-danger text-position">*</span>
					<div class="col-7">
						<input class="form-control m-input" type="text" name="bankName"
							placeholder="Enter the Bank Name" formControlName="bankName">
						<app-form-control-messages [control]="refundBankDetailsForm.controls.bankName"
							[name]="'Bank Name'">
						</app-form-control-messages>
					</div>
				</div>
				<div class="m-form__group form-group row">
					<label for="tp-details" class="col-2 col-form-label">
						Bank Account Number
					</label>
					<span class="text-danger text-position">*</span>
					<div class="col-7">
						<input class="form-control m-input" type="text" name="email"
							placeholder="Enter the Account Number" formControlName="accountNumber">
						<app-form-control-messages [control]="refundBankDetailsForm.controls.accountNumber"
							[name]="'Account Number'"></app-form-control-messages>
					</div>
				</div>
				<div class="m-form__group form-group row">
					<label for="tp-details" class="col-2 col-form-label">
						IFSC Code
					</label>
					<span class="text-danger text-position">*</span>
					<div class="col-7">
						<input class="form-control m-input" type="text" name="ifsceCode"
							placeholder="Enter the IFSC Code" formControlName="ifscCode">
						<app-form-control-messages [control]="refundBankDetailsForm.controls.ifscCode"
							[name]="'IFSC Code'">
						</app-form-control-messages>
					</div>
				</div>
				<div class="m-form__group form-group row">
					<label for="tp-details" class="col-2 col-form-label">
						Account Holder Name
					</label>
					<span class="text-danger text-position">*</span>
					<div class="col-7">
						<input class="form-control m-input" type="text" name="accountHolderName"
							placeholder="Enter Account Holder Name" formControlName="accountHolderName">
						<app-form-control-messages [control]="refundBankDetailsForm.controls.accountHolderName"
							[name]="'Enter Account Holder Name '"></app-form-control-messages>
					</div>
				</div>
				<div class="m-form__group form-group row">
					<label for="tp-details" class="col-2 col-form-label">
						Upload Cancelled Cheque
					</label>
					<span class="text-danger text-position">*</span>
					<div class="col-6">
						<app-upload-file [formValue]="refundBankDetailsForm.get('documentUploaded')"
							[(value)]="localFileName.documentUploaded" fileType="documentUploaded"
							[(localFile)]="localFileName.localFile" info="only jpg, png, jpeg, pdf"></app-upload-file>
						<br>
						<input type="hidden" formControlName="documentUploaded" #fileInput>
						<app-form-control-messages [control]="refundBankDetailsForm.controls.documentUploaded"
							[name]="'Upload Related Document'"></app-form-control-messages>
					</div>
				</div>
				<div class="m-form__group form-group row" style="margin-top: -6%;">
					<label class="col-2 col-form-label"> Disclaimer: </label> <br>
					<div style="color:#6f727d;;margin-left: 5.3%;">I hereby declare that all above information provided
						by me is correct in all aspect and in the event of any misinformation or inaccurate information,
						shall indemnify,
						keep indemnified, hold harmless, defend, protect and fully compensate NSDC.
					</div>
				</div>
				<div class="col-2" style="margin-left: 5%;">
					<label class="m-checkbox">
						<input type="checkbox" formControlName="declaration"> I Agree
						<span> </span>
					</label>
				</div>
				<div class="modal-footer">
					<!-- *ngIf="migratedRefund" -->
					<button type="button" class="btn btn-next" (click)="submitBankDetails()"
						[disabled]="!refundBankDetailsForm.valid || refundBankDetailsForm.get('declaration').value !=true">
						Submit
					</button>
					<!-- <button *ngIf="!migratedRefund" type="button" class="btn btn-next" (click)="submitBankDetails()" [disabled]="!refundBankDetailsForm.valid">
							  Submit
						  </button> -->
					<button type="button" class="btn  btn-cancel" data-dismiss="modal">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>

<div class="modal fade" id="history" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
				</h5>
				<button type="button" class="close" data-dismiss="modal" (click)="closeModel()" aria-label="Close"
					#closeModel>
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="m_datatable m-datatable m-datatable--default m-datatable--loaded" id="local_data">
					<table class="m-datatable__table" style="display: block; min-height: 300px; overflow-x: auto;">
						<thead class="m-datatable__head">
							<tr class="m-datatable__row" style="left: 0px;">
								<th data-field="OrderID" class="m-datatable__cell m-datatable__cell--sort">
									<span style="width: 50px;">S.NO</span>
								</th>
								<th data-field="ShipName" class="m-datatable__cell m-datatable__cell--sort">
									<span style="width: 281px;">Comments</span>
								</th>
								<!-- <th data-field="Currency" class="m-datatable__cell m-datatable__cell--sort">
					  <span style="width: 86px;">Document</span>
					</th> -->
							</tr>
						</thead>
						<tbody class="m-datatable__body"
							*ngIf="conversationHistory && conversationHistory.length > 0; noDataHistory">
							<div *ngFor="let item of conversationHistory;let i = index">
								<tr data-row="0" class="m-datatable__row" style="left: 0px;">
									<td class="m-datatable__cell">
										<span style="width: 50px;">{{i+1}}</span>
									</td>
									<td class="m-datatable__cell" style="width:511px;">
										<b>From {{item.actionTakenByRole}} - {{item.actionTakenByUser}}</b>
										<span>({{item.actionTakenOn | date: 'dd/MM/yyyy'}})</span>
										<table class="newTable" cellpadding="8" cellspacing="0">
											<tr>
												<td>
													<span style="width:281px;">{{item.comment}}</span>
												</td>
											</tr>
										</table>
									</td>
									<!-- <td class="m-datatable__cell">
						<span style="width: 86px;" class="document_link" (click)="downloadDocument(item.documents)">
						  <a>Document</a>
						</span>
					  </td> -->
								</tr>
							</div>
						</tbody>
						<ng-template #noDataHistory>
							<p class="text-danger">No data found...</p>
						</ng-template>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- Model for OTP -->
<div class="modal fade" id="payment_otp" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					OTP has been sent to TC SPOC details (Mobile Number and Email ID)
				</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeModel>
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="modal-body">
				<form class="m-form m-form--fit m-form--label-align-right">
					<div class="m-portlet__body" [formGroup]="otpPaymentForm">
						<div class="m-form__group form-group row">
							<label class="col-3 col-form-label">
								Enter OTP :
							</label>
							<div class="col-9">
								<input type="number" class="form-control" name="Enter OTP" formControlName="otp">
								<app-form-control-messages [control]="otpPaymentForm.controls.otp" [name]="'OTP'">
								</app-form-control-messages>
							</div>
						</div>
					</div> <br>
					<button style="margin-left:87%;" type="button" class="btn  btn-next" data-dismiss="modal"
						(click)="verifiedOtp()">
						Verify
					</button>
				</form>
			</div>
			<div class="modal-footer">

			</div>
		</div>
	</div>
</div>